import $ from 'jquery'

// ルートクラス定義
const ROOT_TARGET_CLASS_NAME = 'js-changeCompleteStatusForSelect-root-target'
const ROOT_TARGET_SELECTOR = `.${ROOT_TARGET_CLASS_NAME}`

// ターゲット要素の定義
const INPUT_TARGET_CLASS_NAME = 'js-changeCompleteStatusForSelect-input-target'
const INPUT_TARGET_SELECTOR = `.${INPUT_TARGET_CLASS_NAME}`

// 状態のクラス定義
const DONE_CLASS_NAME = 'is-done'
const UNTOUCHED_CLASS_NAME = 'is-untouched'

export const changeCompleteStatusForSelect = () => {
  const $rootElement = $(ROOT_TARGET_SELECTOR)

  $rootElement.each((index, root) => {
    const $inputTarget = $(root).find(INPUT_TARGET_SELECTOR)
    const changeStatus = (value) => {
      if (value) {
        $(root).addClass(DONE_CLASS_NAME)
      } else {
        $(root).removeClass(DONE_CLASS_NAME)
      }
    }

    // イベント登録
    $inputTarget.on('change', (event) => changeStatus($(event.currentTarget).val()))
    $inputTarget.on('click', (event) => $(event.currentTarget).removeClass(UNTOUCHED_CLASS_NAME))

    // 初期値判定
    $inputTarget.each((index, element) => {
      const initialValue = $(element).val()

      if (initialValue) {
        $(element).removeClass(UNTOUCHED_CLASS_NAME)
      } else {
        $(element).addClass(UNTOUCHED_CLASS_NAME)
      }

      changeStatus(initialValue)
    })
  })
}
